import env from 'react-dotenv';

//env.config();

export interface UnidadeMinisterial {
  id: number;
  sigla: string;
  nome: string;
}

export interface Membro {
  id: number;
  pessoaFisicaId: number;
  matricula: string;
  pessoaFisicaNome: string;
  dataUltimaSincronizacaoCnmp: string;
}

export interface MensagemRetorno {
  servidor: string;
  idPessoaFisica: number;
  tipoMensagem: string;
  texto: string;
}

export const listarUnidadesMinisteriais = async (token: string) => {
  const url = `${env.APP_API}/cadastro-membros/unidades-organicas`;
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Token ${token}`,
    },
  });

  if (response.status === 200) {
    const unidadesMinisteriais: UnidadeMinisterial[] = await response.json();
    return unidadesMinisteriais;
  } else {
    throw Error('Erro na recuperação de dados');
  }
};

export const listarMembros = async (token: string) => {
  const url = `${env.APP_API}/cadastro-membros/membros`;
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Token ${token}`,
    },
  });

  if (response.status === 200) {
    const membros: Membro[] = await response.json();
    return membros;
  } else {
    throw Error('Erro na recuperação de dados');
  }
};

export const enviarDadosMembros = async ({
  token,
  membroId,
}: {
  token: string;
  membroId: number;
}) => {
  if (membroId === undefined) {
    return [];
  }
  const url = `${env.APP_API}/cadastro-membros/sincronizacao/${membroId}`;

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Token ${token}`,
    },
  });

  if (response.status === 200) {
    const mensagens: MensagemRetorno[] = await response.json();

    return mensagens;
  } else if (response.status === 423) {
    throw Error('Já há uma sincronização em execução no momento.');
  } else {
    throw Error('Erro na recuperação de dados');
  }
};
